import styles from "./StatusPill.module.css";

export type StatusTone = "neutral" | "positive" | "warning";

/**
 * An account-state pill.
 *
 * Deliberately *not* the deal `Badge` from dealbid-web: LTD, Exclusive, Founding Deal,
 * Deal Verified and Sponsored are canon deal signals (contracts/DESIGN-TOKENS.md), and
 * dressing an account status in the same clothes would conflate two different vocabularies.
 *
 * The word is always shown, and the mark differs in shape as well as colour, so the state
 * is never carried by colour alone.
 */
export function StatusPill({
  label,
  tone = "neutral",
  description,
}: {
  label: string;
  tone?: StatusTone | undefined;
  description?: string | undefined;
}) {
  return (
    <span className={`${styles.pill} ${styles[tone]}`} title={description}>
      <svg className={styles.mark} viewBox="0 0 10 10" aria-hidden="true" focusable="false">
        {tone === "positive" ? (
          <path
            d="M1.5 5.2 4 7.6 8.5 2.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : tone === "warning" ? (
          <path
            d="M5 1.4 9.2 8.6H0.8Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        ) : (
          <circle cx="5" cy="5" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
        )}
      </svg>
      {label}
    </span>
  );
}
